import "@mdi/font/css/materialdesignicons.css";
import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/lib/util/colors'
import { ko } from 'vuetify/src/locale';
import VCurrencyField from "v-currency-field";

// v-currency-field
Vue.use(VCurrencyField, {
    locale: "kr-KR",
    decimalLength: 0,
    autoDecimalMode: false,
    defaultValue: 0,
    min: null,
    max: null,
    valueAsInteger: false,
    allowNegative: true,
});

Vue.use(Vuetify);

export const basicTheme = {
    breakpoint: {
        thresholds: {
            xs: 576,
            sm: 768,
            md: 1024,
            lg: 1200,
        },
        scrollBarWidth: 0,
    },
    themes: {
        light: {
            primary: '#22298b',
            secondary: '#366fd7',
            accent: '#3e9b93',
            error: '#FF5252',
            success: '#4CAF50',
            warning: '#FFC107',
            anchor: '#333',
        },
        // dark: {
        //     primary: colors.purple.base,
        //     secondary: '#424242',
        //     accent: '#82B1FF',
        //     error: '#FF5252',
        //     info: '#2196F3',
        //     success: '#4CAF50',
        //     warning: '#FFC107',
        // }
    },
    options: { customProperties: true },
};

export const consoleTheme = {
    themes: {
        light: {
            primary: colors.blue.darken3,
            secondary: '#414c60',
            // accent: '#00C73C',
            accent: colors.blue.lighten1,
            // error: '#FF5252',
            "app-bar": '#2a3141',
            // info: colors.blue.darken4,
            content: "#EDF0F5",
            // success: '#4CAF50',
            // warning: '#FFC107',
            anchor: '#333',
        },
        // dark: {
        //     primary: colors.purple.base,
        //     secondary: '#424242',
        //     accent: '#82B1FF',
        //     error: '#FF5252',
        //     info: '#2196F3',
        //     success: '#4CAF50',
        //     warning: '#FFC107',
        // }
    }
};

/**
 *
 * @param {(basicTheme|consoleTheme)} theme
 * @returns
 */
export default function(theme){
    return new Vuetify({
        breakpoint: {
            mobileBreakpoint: 1024
        },
        lang: {
            locales: { ko },
            current: 'ko',
        },
        theme: theme || basicTheme
    });
}